<template>
    <v-dialog max-width="80%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-text-field
                        class="ma-0 pa-0"
                        label="Test Name"
                        outlined
                        v-model="aBtest.name"
                ></v-text-field>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-textarea
                        outlined
                        v-model="aBtest.message"
                        label="Message"
                ></v-textarea>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mb-3">
                <v-card-text class="grey--text ma-0 pa-0 ml-4">Audiences</v-card-text>
                <v-spacer></v-spacer>
                <v-btn color="green" class="mr-0" icon @click="addAudience()"><v-icon>mdi-plus</v-icon></v-btn>
                <v-btn color="red" class="mr-4" icon @click="removeAudience()"><v-icon>mdi-minus</v-icon></v-btn>
            </v-card-actions>
            <v-card-actions class="py-0 mb-10">
                <v-card width="100%" elevation="0" style="display:flex">
                    <v-card-actions style="width: 100%" class="ma-0 pa-0">
                        <SplitGrid
                                @drag="onDrag"
                                :style="{'margin-right': (aBtest.audiences.length - 1) * 5 + 'px'}"
                                :strictMode="false"
                                class="sb_sub-grid"
                                v-bind="splitGridOptions">
                            <template v-for="(audience, index) in audiences">
                                <SplitGridArea
                                        size-unit="%"
                                        :size-value="audience.percent"
                                        :key="audience.name">
                                    <v-card elevation="0" :color="audience.getColor()">
                                        <v-card-actions>
                                            <h4 style="color: white;" class="ma-0 pa-0">{{ audience.name.toUpperCase() }}</h4>
                                            <h4 style="color: white;" class="ma-0 pa-0">({{ Math.round(audience.percent) }})%</h4>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </SplitGridArea>
                                <SplitGridGutter
                                        :key="audience.name + 's'"
                                        v-show="index != aBtest.audiences.length - 1"
                                        style="background-color: grey; margin: 1px"/>
                            </template>
                        </SplitGrid>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-text-field label="Users (0 - all)" type="number" v-model="aBtest.users" outlined dense :rules="[rules.value]"></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        class="ma-2"
                        color="primary"
                        @click="onPressSave">SAVE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {AudienceTestModel} from "@/modules/maudiences/models/AudienceTestModel";
import {SplitGrid, SplitGridArea, SplitGridGutter} from "vue-split-grid";
import {AudienceModel} from "@/modules/maudiences/models/AudienceModel";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";
import {serialize} from "serializr";

export default {
    name: "a-edit-test-popup",
    props: {},
    components: {SplitGrid, SplitGridArea, SplitGridGutter},
    data: () => ({
        buttonLoading: false,
        dialog: false,
        aBtest: new AudienceTestModel(),
        rules: {
           value: value => Number(value) >= 0 || '> 0',
        },
        splitGridOptions: {
            snapOffset: 0,
            dragInterval: 1,
            minSize: 60//The minimum size in pixels for all track
        },
        characters: 'abcdefghijklmnopqrstuvwxyz',
    }),
    computed: {
        audiences(){
          return this.aBtest.audiences.sort((a, b) => a.name.localeCompare(b.name))
        },
        active(){
            return AudienceTestStoreUtils.getActiveTest()
        }
    },
    methods: {
        show(aBtest, editMode) {
            this.editMode = editMode;
            this.aBtest = aBtest.copy();
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        addAudience(){
            let sum = 0
            this.aBtest.audiences.forEach(function (value, i) {
                sum += 10
                value.percent = 10
                value.name = this.characters[i]
            }.bind(this));
            this.aBtest.audiences.push(new AudienceModel('def', 100 - sum))
        },
        removeAudience(){
            if (this.aBtest.audiences.length == 1){return}
            this.aBtest.audiences.pop();
            let sum = 0
            this.aBtest.audiences.forEach(function (value, i) {
                sum += 10
                value.percent = 10
                value.name = this.characters[i]
            }.bind(this));
            this.aBtest.audiences[this.aBtest.audiences.length - 1].name = 'def'
            this.aBtest.audiences[this.aBtest.audiences.length - 1].percent = 100 - sum + 10
        },
        onPressSave() {
            let sum = this.aBtest.audiences.map(e => Math.round(e.percent)).reduce((a, b) => a + b, 0)
            let delta = 100 - sum
            if (delta > 0) {
                this.aBtest.audiences[0].percent += Math.abs(delta)
            } else if (delta < 0) {
                this.aBtest.audiences[0].percent -= Math.abs(delta)
            }

            for (let a in this.aBtest.audiences) {
                this.aBtest.audiences[a].percent = Math.round(this.aBtest.audiences[a].percent)
            }

            this.aBtest.users = Number(this.aBtest.users);

            if (this.aBtest.name == ""){
                this.$notify({title: 'Invalid Name', type: "error"});
                return;
            }
            this.buttonLoading = true;

            let data = serialize(AudienceTestModel, this.aBtest);
            console.log('editMode: ', this.editMode, 'data: ', data)
            if (!this.editMode){
                AudienceTestStoreUtils.newABTest(data)
                    .then(() => {
                        this.buttonLoading = false
                        this.dialog = false
                        this.$notify({title: 'Test successfully created!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.buttonLoading = false
                        this.dialog = false
                        this.$notify({title: 'Test create failed!', text: error, type: "error"});
                    })
            }else{
                console.log("edit test: ", this.aBtest.id);
                AudienceTestStoreUtils.updateABTest(data)
                    .then(() => {
                        this.buttonLoading = null
                        this.dialog = false
                        this.$notify({title: 'Test successfully updated!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.buttonLoading = null
                        this.dialog = false
                        this.$notify({title: 'Test update failed!', text: error, type: "error"});
                    })
            }
        },
        onDrag({gridTemplateStyle}) {
            let parsed = gridTemplateStyle.split(' ').filter(e => e.includes('%')).map(e => e.replace('%', ''))
            for (let a in this.aBtest.audiences) {
                let percent = Number(parsed[a])
                this.aBtest.audiences[a].percent = percent
            }
        },
    },
}
</script>

<style scoped>
.sb_sub-grid, .sb_split-grid {
    height: 100%;
    width: 100%;
}
</style>